import { CopyGridCells } from '../index'
import { Selection } from '../grid-selection'
import './style.scss'
import { enableCopyMultipleFeature } from '../utils'
function noop () {}


export function tableCellsCopyPlugin (tableInstance) {
  const flag = enableCopyMultipleFeature()
  if (!flag) {
    return {
      lifeCycleHooks: noop
    }
  }
  tableInstance._copySelection = new Selection()
  // 数据发生变化时，清掉状态
  tableInstance.$watch('data', () => {
    tableInstance._copySelection && tableInstance._copySelection.clear()
    tableInstance.highlightCellsArea = {}
  })
  const getUniqueKey = (r, c) => r + '_' + c
  const lifeCycleHooks = () => {
    const setHighlightArea = (rowIndex, columnIndex) => {
      if (rowIndex && columnIndex) {
        const k = getUniqueKey(rowIndex, columnIndex)
        tableInstance.$set(tableInstance.highlightCellsArea, k, true)
      }
    }
    const clearHighlightArea = () => {
      if (Object.keys(tableInstance.highlightCellsArea).length) {
        tableInstance.$set(tableInstance, 'highlightCellsArea', {})
      }
    }
    const deleteItemInHighlightArea = (rowIndex, columnIndex) => {
      if (rowIndex && columnIndex) {
        const k = getUniqueKey(rowIndex, columnIndex)
        tableInstance.$set(tableInstance.highlightCellsArea, k, false)
      }
    }
    tableInstance.$on('hook:mounted', () => {
      tableInstance._copyGridCellsInstance = new CopyGridCells({
        node: tableInstance.$el,
        selection: tableInstance._copySelection,
        handleMouseDownEventCb: (event, copyGridCellsInstance) => {
          let node = event.target
          while (node && node.tagName !== 'TD') {
            node = node.parentNode
          }
          if (!node) {
            return
          }
          const rowIndex = node.getAttribute('data-rowindex')
          const columnIndex = node.getAttribute('data-columnindex')
          const currentCellInfo = {
            val: node.textContent,
            rowIndex,
            columnIndex
          }
          if (copyGridCellsInstance.hasSelection(currentCellInfo)) {
            deleteItemInHighlightArea(rowIndex, columnIndex)
            copyGridCellsInstance.deleteSelection(currentCellInfo)
            return
          }
          if (rowIndex && columnIndex) {
            setHighlightArea(rowIndex, columnIndex)
          }
          copyGridCellsInstance.addSelection(currentCellInfo)
        },
        clear () {
          clearHighlightArea()
        },
        beforeCopy (copyGridCellsInstance) {
          const isCross = copyGridCellsInstance.isGridCross()
          if (isCross) {
            tableInstance.$message.warning('只能复制同行或者同列区域内容')
            return false
          } else {
            return true
          }
        }
      })
    })
    tableInstance.$on('hook:activated', () => {
      tableInstance._copyGridCellsInstance.init()
    })
    tableInstance.$on('hook:deactivated', () => {
      // console.log('-------hook:beforeDestroy')
      tableInstance._copyGridCellsInstance.clearEvent()
    })
    tableInstance.$on('hook:beforeDestroy', () => {
      // console.log('-------hook:beforeDestroy')
      tableInstance._copyGridCellsInstance.clearEvent()
    })
  }

  const init = () => {
    lifeCycleHooks()
  }
  init()
  return {
    lifeCycleHooks,
  }
}



// WEBPACK FOOTER //
// ./src/public/plugins/copy-cells/set-cell-style/element.js